import React from "react";

import logo from '../../../src/assets/images/logo.png'
import meLogo from '../../../src/assets/images/me.jpg'


import AboutApi from '../../Data/HomePage/AboutApi'

function LeftSidebar() {
  
  const today = new Date();
  const year = today.getFullYear();

  return (
    <div>
      <div className="left-sidebar">
        <div className="sidebar-header d-flex align-items-center justify-content-between">
          <img src={logo} alt="Logo" />
          <span className="designation d-block">{AboutApi.info.job_designation}</span>
          {/* <span className="designation">Web Developer</span>  */}
        </div>
        <img className="me" src={meLogo} alt="Me" />
        <h2 className="email">{AboutApi.info.email}</h2>
        <h2 className="address">{AboutApi.info.country}</h2>
        {/* <p className="copyright">&copy;  {year} IMRAN. All Rights Reserved</p> */}
        <ul className="social-profile d-flex align-items-center flex-wrap justify-content-center">
          <li>
            <a href="https://www.linkedin.com/in/md-imran-mia/" target="_blank">
              <i className={AboutApi.info.linkedinIcon}></i>
            </a>
          </li>
          <li>
            <a href="https://github.com/sinbadbd" target="_blank">
              <i className={AboutApi.info.githubIcon}></i>
            </a>
          </li>
        </ul>
        <a href={AboutApi.contactNumber} className="theme-btn">
          <i className={AboutApi.info.contactmeIcon}></i> {AboutApi.info.contactme}
        </a>
      </div>
    </div>
  );
}

export default LeftSidebar;
